import { AccountDetailsTabNameEnum } from '@/epos/vue/pages/account-details/AccountDetailsTabNameEnum';

export function createAccountDetailsStore() {
    return {
        namespaced: true,

        state: {
            /**
             * Will be a CustomerAccount if one is loaded.
             * Will be null if no account has been loaded yet (or is in the process of loading).
             * Will be false if a customer account was requested but was not found.
             *
             * @type {CustomerAccount|null|boolean}
             */
            currentAccount: null,

            /**
             * @type {String}
             */
            activeTabName: '',

            /**
             * @type {Membership[]}
             */
            selectedMemberships: [],

            /**
             * @type {boolean}
             */
            inMembershipEditMode: false,

            /**
             * @type {boolean}
             */
            ordersLoading: false,

            /**
             * @type {OrderSearchResults|null}
             */
            currentAccountOrderSearchResults: null,
        },

        mutations: {
            /**
             * @param {{}} state
             * @param {CustomerAccount|boolean|null} value
             */
            setCurrentAccount(state, value) {
                state.currentAccount = value;
            },

            setActiveTabName(state, value) {
                state.activeTabName = value;
            },

            setOrdersLoading(state, value) {
                state.ordersLoading = value;
            },

            setCurrentAccountOrderSearchResults(state, value) {
                state.currentAccountOrderSearchResults = value;
            },

            setMembershipEditMode(state, value) {
                state.inMembershipEditMode = value;
                if (!value) {
                    state.selectedMemberships = [];
                }
            },

            selectMembership(state, membership) {
                state.selectedMemberships.push(membership);
            },

            deselectMembership(state, membership) {
                state.selectedMemberships = state.selectedMemberships.filter((m) => m.ID !== membership.ID);
            },

            clearSelectedMemberships(state) {
                state.selectedMemberships = [];
            },
        },

        actions: {
            /**
             * @param {function} commit
             */
            clear({ commit }) {
                commit('setCurrentAccount', null);
                commit('setCurrentAccountOrderSearchResults', null);
                commit('setMembershipEditMode', false);
                commit('clearSelectedMemberships');
                // Select the memberships tab by default.
                commit('setActiveTabName', AccountDetailsTabNameEnum.MEMBERSHIPS);
            },
        },
    };
}
